import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
    DKLabel,
    Toggle,
    DKIcon,
    DKButton,
    DKCalendar,
    DKInput,
    DKCheckMark,
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE,
    showAlert
} from "deskera-ui-library";
import ic_info_warning from "../../../../assets/icons/ic_info_gray.svg";
import date_range from "../../../../assets/icons/white/date_range.svg";
import ic_lock from "../../../../assets/icons/white/ic_lock.png";
import ic_unlock from "../../../../assets/icons/white/ic_unlock.png";
import moment from "moment";
import { DATE_FORMAT, FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import CustomInput from "../../../../SharedComponents/CustomInput/CustomInput";
import INComplianceService from "../../../../services/compliance/INComplianceService";
import RouteManager from "../../../../managers/RouteManager";
import { PAGE_ROUTES } from "../../../../managers/RouteManager";
import Utility from "../../../../utility/Utility";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";

function ITDeclaration(props) {
    const history = useHistory();

    const MONTHS = [
        { index: 0, label: 'January', value: 'January' },
        { index: 1, label: 'February', value: 'February' },
        { index: 2, label: 'March', value: 'March' },
        { index: 3, label: 'April', value: 'April' },
        { index: 4, label: 'May', value: 'May' },
        { index: 5, label: 'June', value: 'June' },
        { index: 6, label: 'July', value: 'July' },
        { index: 7, label: 'August', value: 'August' },
        { index: 8, label: 'September', value: 'September' },
        { index: 9, label: 'October', value: 'October' },
        { index: 10, label: 'November', value: 'November' },
        { index: 11, label: 'December', value: 'December' }
    ];
    const [ITDeclarationConfig, setITDeclarationConfig] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const [isConsiderForIT, setIsConsiderForIT] = useState(false);
    const [timePeriod, setTimePeriod] = useState({
        toggle: false,
        startDate: null,
        endDate: null,
        defaultDate: false,
        hasError: false
    });
    const [selectedMonth, setSelectedMonth] = useState({
        month: null,
        hasError: false
    });

    const hasEditAccess = PermissionUtils.hasAccess(MODULE.IT_DECLARATION, ACTION.EDIT);

    const getTimePeriod = () => {
        const shortDateFormat = TenantService.get(TENANT.SHORT_DATE_FORMAT);
        return timePeriod.startDate && timePeriod.endDate ? `${Utility.formatDate(moment(timePeriod.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY, shortDateFormat)} - ${Utility.formatDate(moment(timePeriod.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY, shortDateFormat)}` : '';
    }

    const getTimePeriodText = () => {
        return timePeriod.startDate && timePeriod.endDate ? `Employee can declare their IT saving plan anytime between <span class="fw-m">${Utility.formatDate(moment(timePeriod.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}</span> and the <span class="fw-m">${Utility.formatDate(moment(timePeriod.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}</span>` : '';
    }

    const getSelectedMonthText = () => {
        return `The IT declared amount will be taken into consideration for payroll from <span class="fw-m">${selectedMonth.month.label}</span>.`;
    }

    useEffect(() => {
        RouteManager.setPresenter({props: {...props, history: history}});

        showLoader();
        INComplianceService.getITDeclarationConfig()
        .then((response) => {
            removeLoader();
            if (response) {
                setITDeclarationConfig(response);
                if (response.investmentConfig && response.investmentConfig.declarationConfig) {
                    const declarationConfig = response.investmentConfig.declarationConfig;
                    declarationConfig.forEach((config,index)=>{
                        if(index != declarationConfig.length-1 && declarationConfig.length!=1) {
                            config.active = false;
                        }
                    })
                    const activeConfig = declarationConfig.filter(config => config.active && config.declarationStartDate !== "1900-01-01T00:00:00Z" && config.declarationEndDate !== "1900-01-01T00:00:00Z");
                    if (activeConfig.length !== 0) {
                        setIsEdit(true);
                        setITDeclarationData(activeConfig[0]);
                    }
                }
            }
        });
    }, [])

    const setLockUnlock = () => {
        if (isValidData()) {
            showAlert(
                "Confirm",
                `Are you sure want to ${!isLocked ? "lock" : "unlock"} the IT Declaration?`,
                [
                    {title: "Yes", className: "bg-app text-white mr-l", onClick: () => {
                        setIsLocked(isLocked => !isLocked);
                        saveITDeclarationConfig(!isLocked, true);
                    }},
                    {title: "No", className: "bg-app text-white"}
                ]
            );
        }
    }

    const setITDeclarationData = (config) => {
        setIsLocked(config.declarationLockStatus);
        setTimePeriod({
            toggle: false,
            startDate: moment(config.declarationStartDate, DATE_FORMAT.YYYYMMDD).toDate(),
            endDate: moment(config.declarationEndDate, DATE_FORMAT.YYYYMMDD).toDate(),
            defaultDate: true,
            hasError: false
        });
        setSelectedMonth({
            ...selectedMonth,
            month: MONTHS.find(m => m.value === config.declarationEffectiveMonth)
        });
        setIsConsiderForIT(config.considerForITDeclaration);
    }

    const isValidData = () => {
        let isValid = true;

        if (timePeriod.hasError) {
            isValid = false;
        }

        if (!timePeriod.startDate || !timePeriod.endDate) {
            setTimePeriod({
                ...timePeriod,
                hasError: true,
                errorMsg: "Time Period is required"
            });

            isValid = false;
        }

        if (isConsiderForIT && !selectedMonth.month) {
            setSelectedMonth({
                ...selectedMonth,
                hasError: true
            });

            isValid = false;
        }

        return isValid;
    }

    const getStringDate = (date) => {
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON();
    }

    const buildPayload = (isLocked, isLockUnlock) => {
        const config = {
            id: "",
            active: true,
            considerForITDeclaration: isConsiderForIT,
            declarationEffectiveMonth: isConsiderForIT ? selectedMonth.month.label : "",
            declarationEndDate: getStringDate(timePeriod.endDate),
            declarationLockStatus: isLocked,
            declarationStartDate: getStringDate(timePeriod.startDate)
        };

        if (isLockUnlock) {
            const activeConfig = ITDeclarationConfig.investmentConfig.declarationConfig.find(config => config.active && config.declarationStartDate !== "1900-01-01T00:00:00Z" && config.declarationEndDate !== "1900-01-01T00:00:00Z");
            config.id = activeConfig.id;
            config.updateLock = true;
        }

        const investmentConfig = {
            declarationConfig: [config]
        };

        return {
            ...TenantService.get(TENANT.CONFIG),
            confId: ITDeclarationConfig.confId,
            countryCode: ITDeclarationConfig.countryCode,
            investmentConfig: investmentConfig,
            tenantId: ITDeclarationConfig.tenantId,
        }
    }

    const saveITDeclarationConfig = (isLocked, isLockUnlock) => {
        if (isValidData()) {
            showLoader("Updating...Please wait");
            const payload = buildPayload(isLocked, isLockUnlock);
            INComplianceService.setITDeclarationConfig(payload).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        setITDeclarationConfig(response);
                        if (isLockUnlock) {
                            showToast(`IT Declaration is now ${isLocked ? 'locked' : 'unlocked'}.`, TOAST_TYPE.SUCCESS);
                        } else {
                            showToast('IT Declaration updated successfully.', TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    return(
        <div className="parent-width">
            <div className="row">
                <DKLabel className="fw-m fs-l mr-m" text="IT Declaration"/>
                {isEdit && <div className="p-h-m p-v-s border-radius-s bg-gray4" style={{ display: "flex" }}>
                    {isLocked && <DKIcon className="mr-s ic-xs-2" src={ic_lock} style={{ filter: "contrast(0)" }}/>}
                    {!isLocked && <DKIcon className="mr-s ic-xs-2" src={ic_unlock} style={{ filter: "contrast(0)" }}/>}
                    {isLocked ? "Locked" : "Unlocked"}
                </div>}
            </div>
            <div className="row m-v-m" style={{ pointerEvents: hasEditAccess ? "" : "none" }}>
                <Toggle className="mr-s border-n" isOn={isLocked} onChange={() => setLockUnlock()} />
                <span className="mb-xs">Lock IT Declaration</span>
            </div>
            <div className="bg-white border-radius-s shadow-s column" style={{ pointerEvents: hasEditAccess ? "" : "none" }}>
                <div className="row p-v-m p-h-m bg-deskera-secondary">
                    <DKIcon className="mr-s" src={ic_info_warning} />Employee can declare their tax saving investments and expense details through the employee portal once you enable this option.
                </div>
                <div className="p-h-l p-v-l">
                    <DKLabel className="fw-m" text={"Allow employees to submit IT Declaration through the employee portal and lock on the selected date"}/>
                    <div style={{ width: "340px"}}>
                        <div className="row mt-l">
                            <DKInput
                                title={"Time Period"}
                                type={INPUT_TYPE.TEXT}
                                value={getTimePeriod()}
                                required={true}
                                readOnly={true}
                            />
                            <DKIcon
                                className={`mr-s cursor-hand z-index-1 margin-top-mobile ${isLocked ? "pointer-events-none" : ""}`}
                                style={{
                                    marginLeft: "-30px",
                                    filter: "contrast(0.5)",
                                    pointerEvents: isLocked || !hasEditAccess ? "none" : "initial"
                                }}
                                src={date_range}
                                onClick={() => {
                                    setTimePeriod({
                                        toggle: true,
                                        startDate: timePeriod.startDate,
                                        endDate: timePeriod.endDate,
                                        defaultDate: true,
                                        hasError: false
                                    })
                                }}
                            />
                            {timePeriod.toggle && <DKCalendar
                                className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                isDateRange={true}
                                startDate={timePeriod.startDate ? new Date(timePeriod.startDate) : new Date()}
                                endDate={timePeriod.endDate ? new Date(timePeriod.endDate) : new Date()}
                                onClose={()=>{
                                    if(moment(timePeriod.startDate).diff(timePeriod.endDate) <= 0 || timePeriod.endDate == null) {
                                        setTimePeriod({
                                            toggle: false,
                                            startDate: timePeriod.startDate,
                                            endDate: timePeriod.endDate,
                                            defaultDate: false,
                                            hasError: false
                                        });
                                    } else {
                                        setTimePeriod({
                                            toggle: false,
                                            startDate: timePeriod.startDate,
                                            endDate: timePeriod.endDate,
                                            defaultDate: false,
                                            hasError: true,
                                            errorMsg: "End date should not be less than Start date"
                                        });
                                    }
                                }}
                                onSelectDate={(start, end) => {
                                    if(start && end) {
                                        let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                                        let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                                        if(moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                            setTimePeriod({
                                                toggle: false,
                                                startDate: startDate,
                                                endDate: endDate,
                                                defaultDate: false,
                                                hasError: false
                                            });
                                        } else {
                                            setTimePeriod({
                                                toggle: false,
                                                startDate: startDate,
                                                endDate: endDate,
                                                defaultDate: false,
                                                hasError: true,
                                                errorMsg: "End date should not be less than Start date"
                                            });
                                        }
                                    }
                                }}
                                
                            />}
                        </div>
                        {timePeriod.hasError && <DKLabel
                                className="mt-xs text-red"
                                style={{marginLeft: "95px"}}
                                text={timePeriod.errorMsg}
                        />}
                    </div>
                    <DKLabel className="mt-l" text={getTimePeriodText()}/>
                    <div className="row mt-l">
                        <DKCheckMark
                            className={ isLocked ? "pointer-events-none" : "" }
                            isSelected={isConsiderForIT}
                            onClick={() => setIsConsiderForIT(isConsiderForIT => !isConsiderForIT)}
                        />
                        <DKLabel className="fw-m ml-s" text={"Consider for IT"}/>
                    </div>
                    {isConsiderForIT && <div className="row row-responsive mt-l">
                        <div className={isLocked ? "pointer-events-none" : ""} style={{ width: "200px"}}>
                            <CustomInput
                                type={INPUT_TYPE.SELECT}
                                labelName={"Select Month"}
                                labelClassName="text-align-left"
                                options={MONTHS}
                                defaultValue={selectedMonth.month ? selectedMonth.month.index : null}
                                hasError={selectedMonth.hasError}
                                errorMsg={"Month is required"}
                                isRequired={true}
                                onChange={(value) => {
                                    setSelectedMonth({
                                        ...selectedMonth,
                                        month: value
                                    });
                                }}
                            />
                        </div>
                        {selectedMonth.month && <div className="ml-xxl mb-s margin-empty-mobile" style={{ display: "flex", alignItems: "center" }}>
                                <DKIcon className="mr-s" src={ic_info_warning} />
                                <DKLabel text={getSelectedMonthText()}/>
                        </div>}
                    </div>}
                </div>
            </div>
            {!isLocked && <div className="row p-v-l">
                {hasEditAccess &&
                    <DKButton
                        title="Save"
                        className="bg-app text-white mr-m"
                        onClick={() => {
                            saveITDeclarationConfig(isLocked, false);
                        }}
                    />
                }
                <DKButton
                    title="Cancel"
                    className="bg-app text-white"
                    onClick={() => {
                        RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                    }}
                />
            </div>}
        </div>
    );
}

export default ITDeclaration;
